import AccompanyingSheet from './AccompanyingSheet'
import AccompanyingSheetDisplay from './AccompanyingSheetDisplay'
import AddThirdPartiesTypesForm from './AddThirdPartiesTypesForm'
import AutoHideNotification from './AutoHideNotification'
import Button from './Button'
import CallbackModal from './CallbackModal'
import Card from './Card'
import CharacterCounter from './CharacterCounter'
import CheckableTreeView from './CheckableTreeView'
import CheckableTreeViewItem from './CheckableTreeViewItem'
import Checkbox from './Checkbox'
import CheckMark from './CheckMark'
import Child from './Child'
import Decisions from './Decisions'
import DecisionsReport from './DecisionsReport'
import DropDownSearch from './DropDownSearch'
import DropDownSearchProfiles from './DropDownSearchProfiles'
import Evaluation from './Evaluation'
import EvaluationBadge from './EvaluationBadge'
import Evaluations from './Evaluations'
import FiveSelector from './FiveSelector'
import FormError from './FormError'
import ISCOSelector from './ISCOSelector'
import ISCOSelectorModal from './ISCOSelectorModal'
import LicensesModal from './LicensesModal'
import Login from './Login'
import Logo from './Logo'
import MaskDisplay from './MaskDisplay'
import MaskModal from './MaskModal'
import MasksSelector from './MasksSelector'
import OrganizationEditor from './OrganizationEditor'
import PaginationBlock from './PaginationBlock'
import PenibilityDisplay from './PenibilityDisplay'
import PerceptionsTable from './evaluations/PerceptionsTable'
import ProfileDisplay from './ProfileDisplay'
import ProfilesSelector from './ProfilesSelector'
import RadarChart from './RadarChart'
import ReportCommentsDisplay from './ReportCommentsDisplay'
import ReportDisplay from './ReportDisplay'
import ReportHeader from './ReportHeader'
import Reports from './Reports'
import RequirementsTable from './evaluations/RequirementsTable'
import SkillsTable from './evaluations/SkillsTable'
import Spinner from './Spinner'
import SynthesisDisplay from './SynthesisDisplay'
import TreeView from './TreeView'
import TreeViewItem from './TreeViewItem'
import Vue from 'vue'
import YesNoDetails from './YesNoDetails'

import { HasError, AlertError, AlertSuccess } from 'vform'

// Components that are registered globaly.
[
  AccompanyingSheet,
  AccompanyingSheetDisplay,
  AddThirdPartiesTypesForm,
  AlertError,
  AlertSuccess,
  AutoHideNotification,
  Button,
  CallbackModal,
  Card,
  CharacterCounter,
  CheckableTreeView,
  CheckableTreeViewItem,
  Checkbox,
  CheckMark,
  Child,
  Decisions,
  DecisionsReport,
  DropDownSearch,
  DropDownSearchProfiles,
  Evaluation,
  EvaluationBadge,
  Evaluations,
  FiveSelector,
  FormError,
  HasError,
  ISCOSelector,
  ISCOSelectorModal,
  LicensesModal,
  Login,
  Logo,
  MaskDisplay,
  MaskModal,
  MasksSelector,
  OrganizationEditor,
  PaginationBlock,
  PenibilityDisplay,
  PerceptionsTable,
  ProfileDisplay,
  ProfilesSelector,
  RadarChart,
  ReportDisplay,
  ReportCommentsDisplay,
  ReportHeader,
  Reports,
  RequirementsTable,
  SkillsTable,
  Spinner,
  SynthesisDisplay,
  TreeView,
  TreeViewItem,
  YesNoDetails
].forEach(Component => {
  Vue.component(Component.name, Component)
})



// WEBPACK FOOTER //
// ./resources/js/components/index.js